import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, ChatService, SocketService } from 'angular-lib';
import { ReportPopupComponent } from '../popup/types/report/popup-report.component';
import { PopupService } from '../../services/popup.service';
import { PictureAuthPopupComponent } from '../popup/types/pictureAuth/popup-picture-auth.component';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { MenuService } from '../../services/menu.service';

@Component({
    selector: 'ez-chat-action',
    styles: [require('./chat-actions.component.less')],
    template: require('./chat-actions.component.html'),
})

export class ChatActionsComponent {
    private userId: number;

    constructor(
        private router: Router,
        private apiService: ApiService,
        private popupService: PopupService,
        private menuService: MenuService,
        private socketService: SocketService,
        private chatService: ChatService
    ) {
        let match = router.url.match('/chat/([0-9]+)$');
        if (match && match.length) {
            let userId = match[1];
            this.userId = Number(userId);
            this.menuService.setUser(this.userId);
        }
    }

    public togglePictureAuth() {
        this.closeMenu();
        this.popupService.showPopup(PictureAuthPopupComponent, {
            displayName: this.menuService.user.displayname,
            hasAuth: this.menuService.user.pictureAuthorization.given
        }).subscribe(data => {
            if (!data.result) {
                this.popupService.close();
            }
            let body = {userIdTo: this.menuService.user.id};
            let response: Observable<Response>;
            if (this.menuService.user.pictureAuthorization.given) {
                response = this.apiService.delete('/ws/profile/picturesAuthorization', {body: body});
            } else {
                response = this.apiService.put('/ws/profile/picturesAuthorization', body);
            }
            response.subscribe(authResponse => {
                this.popupService.showFeedBack(true);
                this.apiService.user(this.menuService.user.id).subscribe(user => {
                    this.menuService.user = user;
                    this.chatService.sendPictureAuthStatus(this.userId, this.menuService.user.pictureAuthorization.given);
                });
            });
        });
    }

    public reportAbuse() {
        this.closeMenu();
        // we need to get different abuse types
        this.apiService.miscConfig().subscribe(conf => {
            if (conf.hasOwnProperty('abuseTypes')) {
                this.popupService.showPopup(ReportPopupComponent, {
                    displayName: this.menuService.user.displayname,
                    hasAuth: this.menuService.user.pictureAuthorization.given,
                    abuseTypes: conf.abuseTypes
                }).subscribe(data => {
                    this.apiService.reportAbuse(this.menuService.user.id, data.reason).subscribe((res) => {
                        this.popupService.showFeedBack(true);
                    });
                });
            }
        });
    }

    public deleteContact() {
        this.closeMenu();
        this.apiService.deleteContact(this.menuService.user.id).subscribe(data => {
            // if it works, go back to the chat list
            if (data.success === true) {
                this.router.navigate(['member/chat']);
            }
        });
    }

    public closeMenu() {
        this.menuService.hideSelectedActionBar();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/chat/chat-actions.component.ts